import React from 'react';
import { Loader } from 'semantic-ui-react';

export default () => <Loader active>Loading user...</Loader>;
